import Mixpanel from 'mixpanel-browser'

import { generateTypes, getType } from 'helpers/actions'
import { isLoggedIn, isAdmin, userId, userToken, getUser, setAuth, removeAuth } from 'helpers/auth'

// Actions
export function login (data, dispatch, { location }) {
  data = { // clean stuff up as logins should be clean
    email: data.email.trim(),
    password: data.password && data.password.trim(),
    magic_token: data.magic_token && data.magic_token.trim()
  }

  Mixpanel.track('Login', {
    email: data.email,
    using_token: !!data.magic_token
  })

  return (dispatch) => {
    dispatch({
      types: generateTypes('login'),
      api: api => api('auth', { method: 'post', body: data }, false),
      onApiSuccess: (nextAction) => {
        if (location.query && location.query.nextPath) {
          nextAction.redirectTo = location.query.nextPath
        } else {
          nextAction.redirectTo = '/'
        }

        return nextAction
      }
    })
  }
}

export function passwordless (email) {
  return (dispatch) => {
    dispatch({
      types: generateTypes('passwordless'),
      api: api => api('auth/magic', {
        method: 'post',
        body: { email }
      }, false)
    })
  }
}

export function logout (message) {
  Mixpanel.track('Logout')

  return (dispatch) => {
    dispatch({
      type: getType('logout', 'request'),
      redirectTo: '/login',
      notify: { type: 'notice', message: 'You have been logged out.' }
    })
  }
}

export const actions = {
  login,
  logout
}

const loggedOutState = {
  isLoggedIn: false,
  isAdmin: false,
  userToken: false,
  user: {},
  userId: false
}

// Action Handlers
const ACTION_HANDLERS = {
  'MISSING_LOGIN_TOKEN': (state, action) => loggedOutState,
  [getType('login', 'success')]: (state, action) => {
    setAuth(action.payload)

    return {
      isLoggedIn: true,
      isAdmin: !!action.payload.user.is_admin,
      userToken: action.payload.user_token,
      user: action.payload.user,
      userId: action.payload.user.id
    }
  },
  [getType('login', 'failure')]: (state, action) => loggedOutState,
  [getType('logout', 'request')]: (state, action) => {
    removeAuth()
    return loggedOutState
  }
}

// Reducer
const initialState = {
  isLoggedIn: isLoggedIn(),
  isAdmin: isAdmin(),
  userId: userId(),
  userToken: userToken(),
  user: getUser()
}

export default function (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/Auth/modules/auth.js